import { QuerySearchFilter } from './query-parameter.action';
import { TroughModel } from 'franke-trough-dependencies';

export interface FilterStateProps {
  exos: boolean;
  varius: boolean;
  variusmed: boolean;
  square: boolean;
  oval: boolean;
  round: boolean;
  overflowWith: boolean;
  overflowWithout: boolean;
  preparedBackWallWith: boolean;
  preparedBackWallWithout: boolean;
}

export const filterStateProps: FilterStateProps = {
  exos: false,
  varius: false,
  variusmed: false,
  square: false,
  oval: false,
  round: false,
  overflowWith: false,
  overflowWithout: false,
  preparedBackWallWith: false,
  preparedBackWallWithout: false,
};

export type ActiveFilterValue = 'exos' | 'varius' | 'variusmed' | 'square' | 'oval' | 'round' | 'overflowWith' | 'overflowWithout' | 'preparedBackWallWith' | 'preparedBackWallWithout';

export const setFilters =  (fromQuery: QuerySearchFilter, filters: FilterStateProps = filterStateProps): FilterStateProps => {
  const keys = Object.keys(filters);
  keys.map(key => {
    let filter = false;
    if (fromQuery && fromQuery[key]) {
      filter = true;
    } else {
      filter = false;
    }
    filters[key] = filter;
  });
  return filters;
};

export const listOfActiveFilters = (filters: FilterStateProps): ActiveFilterValue[] | undefined => {
  const activeFilter: ActiveFilterValue[] = [];
  const keys = Object.keys(filters);
  keys.map(key => filters[key] && filters[key] === true && activeFilter.push(key as ActiveFilterValue));
  return activeFilter && activeFilter.length > 0 ? activeFilter : undefined;
};

export const checkIfTroughIsActive = (trough: TroughModel, activeList: ActiveFilterValue[]): boolean => {
  let isActive = activeList.some((filter) => {
    if (trough[filter] && trough[filter] === true) {
      return true;
    }
    return false;
  });
  return isActive;
};
